export enum NoteTypeEnum {
  whole,
  half,
  quarter,
  lessThanQuarter,
}